require('./armusscript_extensions')
require('./Object.assign')
require('./Object.values')

Hybrid = module.exports
# namespaced stuff

Hybrid.FileInfo = require('./FileInfo').default

Hybrid.error = require('./error').default

# internal stuff
Hybrid.__unload = require('./_unload').default

# augmentations
Hybrid.error.byCode = require('./error.byCode')
Backbone.Model.prototype.keys = require('./Backbone.Model.keys')

Hybrid



// WEBPACK FOOTER //
// ./app/jsmodel/Hybrid.coffee